import React from "react";

function Icon({ color, viewBox = "0 0 24 24", className = "" }) {
  return (
    <svg data-testid="like-icon" xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} className={className} width="24" height="24" fill="none">
      <path
        stroke={color || "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M7.2 20H4v-7.467h3.2M7.2 12.533L10.4 4h1.066c.59 0 1.067.478 1.067 1.067V10.4h5.332a2.133 2.133 0 012.056 2.704l-1.482 5.333A2.133 2.133 0 0116.384 20H7.2v-7.467z"
      ></path>
    </svg>
  );
}

export default Icon;
